import styled from 'styled-components';

interface EditorCustomStyledProps {
  disabledEditor?: boolean;
}
export const EditorCustomStyled = styled.div<EditorCustomStyledProps>`
  position: relative;

  .loading-editor {
    position: absolute;
    right: 2%;
    bottom: 0%;
    z-index: 1000;
    .Polaris-Spinner svg {
      fill: #a28c8c;
    }
  }

  * .rsw-btn {
    cursor: ${(props) => (props.disabledEditor ? 'not-allowed' : 'auto')};
    pointer-events: ${(props) => (props.disabledEditor ? 'none' : 'auto')};
  }
`;
